// extracted by mini-css-extract-plugin
export default {"button":"Button_button__HKZdh","invert":"Button_invert__mmqXE"};